export enum StatusEnum
{
    inactive,
    active,
}
